module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.store.state.currentNeighborhood),
      expression: "store.state.currentNeighborhood"
    }],
    staticClass: "aesthetics",
    attrs: {
      "id": "aesthetics"
    }
  }, [_c('h3', [_vm._v("What do people take photos of in " + _vm._s(_vm.store.state.currentNeighborhood))]), _vm._v("\n  Photos are from Flickr; selected photos have tags that appear more often in " + _vm._s(_vm.store.state.currentNeighborhood) + " than in other neighborhoods."), _c('br'), _vm._v("\n  Indoor photos: " + _vm._s(_vm.indoor_outdoor[0]) + ", outdoor photos: " + _vm._s(_vm.indoor_outdoor[1]) + "\n  "), _c('div', {
    attrs: {
      "id": "toggle_link"
    },
    on: {
      "click": function($event) {
        _vm.should_display = !_vm.should_display
      }
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.should_display),
      expression: "should_display"
    }]
  }, [_vm._v("Hide photos")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.should_display),
      expression: "!should_display"
    }]
  }, [_vm._v("Show photos")])]), _vm._v(" "), _c('table', _vm._l((_vm.top10tags), function(tag) {
    return _c('tr', [_c('td', {
      staticClass: "autotag_name"
    }, [(tag['autotag'] == 'blackandwhite') ? _c('span', [_vm._v("black and white")]) : _c('span', [_vm._v(_vm._s(tag['autotag']))])]), _vm._v(" "), (_vm.should_display) ? _c('td', _vm._l(([0, 1, 2, 3, 4]), function(i) {
      return _c('span', [(i < tag['example_url'].length) ? _c('a', {
        attrs: {
          "href": tag['example_url'][i]
        }
      }, [_c('img', {
        staticClass: "preview_photo",
        attrs: {
          "src": tag['example_url'][i]
        }
      })]) : _vm._e()])
    }), 0) : _vm._e()])
  }), 0), _vm._v(" "), _c('br')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7293fcbf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aesthetics.vue
// module id = 180
// module chunks = 1